import { motion } from 'motion/react';
import { Button, Progress } from '@ideoz/ui';
import type { Step1Props, Persona } from '../types';
import { Badge } from './Badge';
import { IdeozLogo } from './IdeozLogo';

const badges: Persona[] = ['Freelance', 'Work', 'Personal', 'Education', 'Others'];

export function Step1({ selectedPersona, onSelectPersona, onContinue, isContinueDisabled }: Step1Props): JSX.Element {
  return (
    <motion.div
      key="step1"
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: 20 }}
      transition={{ duration: 0.3 }}
      className="flex flex-col h-full"
    >
      <header className="flex flex-col gap-12">
        <IdeozLogo />

        <div className="flex flex-col gap-3 items-start justify-center ">
          <h2 className="text-primary-900 font-semibold text-3xl">How do you plan to use ideoz?</h2>
          <p className="text-gray-900 text-xl">
            We use this answer to personalize your experience by time
          </p>
        </div>
      </header>

      <div className="flex flex-wrap gap-3 mt-24 mb-12">
        {badges.map((badge) => (
          <motion.div
            key={badge}
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.35, delay: badges.indexOf(badge) * 0.09 }}
            exit={{ opacity: 0 }}
            className="flex-1 lg:flex-none"
          >
            <Badge
              text={badge}
              isSelected={selectedPersona === badge}
              onClick={() => onSelectPersona(badge)}
            />
          </motion.div>
        ))}
      </div>

      <div className="flex justify-between items-center mt-auto">
        <div className="w-40 flex items-center gap-4">
          <Progress value={50} />
          <span className="text-sm text-gray-500">1/2</span>
        </div>
        <Button variant="primary" size="lg" onClick={onContinue} disabled={isContinueDisabled}>
          Continue
        </Button>
      </div>
    </motion.div>
  );
}
